/**
 * 获取图片url
 * @param {Number} id 
 */
export function render(id,from) {
    return process.env.VUE_APP_PICTURE_RENDER + `/${id}`;
}

/**
 * 校验图片的大小
 * @param {File} file 
 */
export function validatePictureSize(file) {
    const isJPG = file.type === "image/jpeg";
    const isPNG = file.type === "image/png";
    const isGif = file.type === "image/gif";
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isJPG && !isPNG && !isGif) {
        this.$message.error("上传头像图片只能是 JPG,PNG,GIF 格式!");
    }
    if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return (isJPG||isGif||isPNG) && isLt2M;
}

/**
 * 校验图片的宽度
 * @param {File} file 
 * @param {Number} width 
 * @param {NUmber} height 
 */
export function validatePictureWidthHeight(file, width, height) {
    return new Promise((resolve,reject)=>{
        let _URL = window.URL || window.webkitURL;
        let image = new Image();
        let valid;
        image.src = _URL.createObjectURL(file);
        image.onload = function () {
            valid = image.width <= width && image.height <= height;
            if (valid) {
                resolve();
            } else {
                this.$message({
                    message:"上传图片尺寸不符合,只能是" + width + "*" + height + "!",
                    type:'error'
                });
                reject();
            }
        };
    }).then(()=>{
        return true
    }).catch(()=>{
        return false;
    })
    

}


// WEBPACK FOOTER //
// ./src/utils/pictureUtil.js